<template>
  <div class="social">
    <a v-for="s in socials" :key="s.label" :href="s.href" :aria-label="s.label" target="_blank" rel="noopener">
      <Github v-if="s.icon === 'github'" />
      <Linkedin v-else-if="s.icon === 'linkedin'" />
      <img v-else class="mono" :src="s.img" alt="" width="18" height="18" />
    </a>
  </div>
</template>

<script>
import { Github, Linkedin } from "lucide-vue-next";
import { SOCIALS } from "@/content";

export default {
  name: "SocialLinks",
  components: { Github, Linkedin },
  setup: () => ({ socials: SOCIALS }),
};
</script>
